(function () {
  /* --------------------------------------------------
     DEMO PLAYER (lazy: placeholder direct zichtbaar,
     WaveSurfer + audio pas geladen bij eerste klik)
  -------------------------------------------------- */

function renderPlaceholder(waveEl) {
    const wrap = document.createElement('div');
    wrap.className = 'waveform-placeholder';
    wrap.setAttribute('aria-hidden', 'true');

    // Herhalend hoogtepatroon (%) voor een natuurlijke, "echte" waveform-look
    const pattern = [30,55,80,45,65,25,90,50,35,70,20,60,85,40,30,75,55,25,65,45,90,35,60,20,80,50,30,70,40,85];

    const barTotal = 4; // 2px balk + 2px gap, zelfde als de echte WaveSurfer-instellingen
    const width = waveEl.clientWidth || 300;
    const barCount = Math.max(20, Math.floor(width / barTotal));

    let bars = '';
    for (let i = 0; i < barCount; i++) {
      const h = pattern[i % pattern.length];
      bars += `<span style="height:${h}%"></span>`;
    }
    wrap.innerHTML = bars;

    waveEl.appendChild(wrap);
  }

function createRealPlayer(src, waveEl) {
    // NIET meer: waveEl.innerHTML = '';
    // WaveSurfer voegt zijn eigen elementen toe náást de placeholder;
    // de placeholder blijft dus even staan zodat de container zijn
    // juiste breedte behoudt tijdens het aanmaken/meten.

    const ws = WaveSurfer.create({
      container: waveEl,
      height: 32,
      barWidth: 2,
      barGap: 2,
      cursorWidth: 0,
      normalize: true,
      waveColor: '#bfbfbf',
      progressColor: '#d51ad7',
      url: src
    });

    window.__WAVE_PLAYERS__.add(ws);
    return ws;
  }

  function initDemoAudioPlayer() {
    document
      .querySelectorAll('.demo-audio-player [data-wave-player]')
      .forEach(el => {
        if (el.dataset.ws === '1') return;
        el.dataset.ws = '1';

        const src = el.dataset.audio;
        if (!src) return;

        const root = el.closest('.demo-audio-player');
        const btn = el.querySelector('.btn');
        const playIcon = el.querySelector('.icon-play');
        const pauseIcon = el.querySelector('.icon-pause');
        const waveEl = el.querySelector('.waveform');

        if (!btn || !waveEl) return;

        renderPlaceholder(waveEl);

        let ws = null;
        let loading = false;

        const sync = () => {
          if (!ws) return;
          const playing = ws.isPlaying();
          playIcon.classList.toggle('hidden', playing);
          pauseIcon.classList.toggle('hidden', !playing);
          root && root.classList.toggle('is-playing', playing);
        };

        btn.addEventListener('click', () => {
          if (ws) {
            pauseAllExcept(ws);
            ws.playPause();
            return;
          }

          if (loading) return;
          loading = true;
          btn.classList.add('is-loading');

          window.loadWaveSurfer()
            .then(() => {
              ws = createRealPlayer(src, waveEl);

              ws.on('play', sync);
              ws.on('pause', sync);
              ws.on('finish', sync);
            ws.on('ready', () => {
                loading = false;
                btn.classList.remove('is-loading');

                const placeholder = waveEl.querySelector('.waveform-placeholder');
                if (placeholder) placeholder.remove();

                pauseAllExcept(ws);
                ws.playPause();
              });
            })
            .catch(() => {
              loading = false;
              btn.classList.remove('is-loading');
            });
        });
      });
  }

  function initAll() {
    initDemoAudioPlayer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();